import { useEffect, useRef, useState } from "react";
import { Eye, Loader2 } from "lucide-react";
import api from "@/lib/api";

export function EmailPreview({ templateKey, lang, overrides }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [height, setHeight] = useState(420);
  const frame = useRef(null);
  const body = JSON.stringify(overrides);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const id = setTimeout(() => {
      api.post(`/admin/email-templates/${templateKey}/preview`, { overrides: JSON.parse(body), lang })
        .then((r) => { if (alive) { setData(r.data); setError(""); } })
        .catch(() => { if (alive) setError("Nie udało się wygenerować podglądu."); })
        .finally(() => { if (alive) setLoading(false); });
    }, 500);
    return () => { alive = false; clearTimeout(id); };
  }, [templateKey, lang, body]);

  const fit = () => {
    const h = frame.current?.contentDocument?.body?.scrollHeight;
    if (h) setHeight(Math.min(Math.max(h + 24, 240), 1400));
  };

  return (
    <div data-testid={`email-preview-${templateKey}`} className="lg:sticky lg:top-6 self-start">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-muted-foreground inline-flex items-center gap-1.5"><Eye size={12} /> Podgląd wiadomości ({lang.toUpperCase()})</span>
        {loading && <Loader2 size={12} className="animate-spin text-muted-foreground" />}
      </div>
      <div className="rounded-xl border border-border overflow-hidden bg-white">
        <div className="px-4 py-2.5 border-b border-slate-200 bg-slate-50 text-slate-900">
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">Temat</div>
          <div data-testid={`email-preview-subject-${templateKey}`} className="text-sm font-semibold truncate">{data?.subject || "…"}</div>
        </div>
        {error ? (
          <p data-testid={`email-preview-error-${templateKey}`} className="p-4 text-sm text-brand-red">{error}</p>
        ) : (
          <iframe
            ref={frame}
            title="Podgląd e-maila"
            data-testid={`email-preview-frame-${templateKey}`}
            sandbox="allow-same-origin"
            srcDoc={data ? `<!doctype html><html><head><meta charset="utf-8"><base target="_blank"><style>body{margin:0;background:#fff;color:#111}a{pointer-events:none}</style></head><body>${data.html}</body></html>` : ""}
            onLoad={fit}
            style={{ height }}
            className={`w-full block transition-opacity duration-200 ${loading ? "opacity-60" : "opacity-100"}`}
          />
        )}
      </div>
      <p className="text-[11px] text-muted-foreground mt-2">Przykładowe dane zamówienia. Podgląd odświeża się automatycznie po każdej zmianie — także przed zapisaniem.</p>
    </div>
  );
}
